module.exports = require('electron');